module.exports = __webpack_public_path__ + "static/media/polytope_5_52_5_layers_2_2.ea87bbc1.gif";